import {ReactElement} from "react";
import {UserService} from "./entity/UserService";
import {UserFullState} from "../state/cache/UserFullState";
import {ApplicationPropertiesState} from "../state/cache/ApplicationPropertiesState";

export interface AdAuthenticateProps {
    applicationPropertiesState: ApplicationPropertiesState;
    currentUserState: UserFullState;
    children: ReactElement;
}

export function AdAuthenticate(props: AdAuthenticateProps) {
    const userService = new UserService();

    // Check application property
    if (!props.applicationPropertiesState.applicationProperties ||
        !props.applicationPropertiesState.applicationProperties.enableAds) {
        return null;
    }

    // If admin user, don't show ad
    if (props.currentUserState.userFull &&
        userService.isAdmin(props.currentUserState.userFull)) {
        return null;
    }

    return props.children;
}